import { ETime } from '@domain/enums/dashboard/automations/node/waitNode/ETime';
import { ITime } from '@domain/interfaces/dashboard/Automations/Canvas/Node/WaitNode/IWaitNodeModal';

export const selectDefaultWaitNodeContent = (): ITime => {
  return {
    unit: ETime.SECONDS,
    amount: '',
  };
};
